export function centHundredthsToString(centHundredths: number): string {
    const inDollars = centHundredths / 10000;
    const fixed = Math.abs(inDollars).toFixed(4);
    return `${centHundredths < 0 ? "-" : ""}$${fixed}`;
}
